import type { InternalActionSheetButton, InternalActionSheetOptions } from "./types";
import type {
  Placement,
  VerticalOrigin,
  HorizontalOrigin
} from "./DropdownActionSheet.types";
import { LAYOUT } from "./DropdownActionSheet.constants";

export interface PlacementResult {
  placement: Placement;
}

export function calculatePlacement(
  triggerPosition: { x: number; y: number },
  options: InternalActionSheetOptions<readonly InternalActionSheetButton[]>
): PlacementResult {
  const estimatedHeaderHeight =
    options.title || options.message ? LAYOUT.HEADER_HEIGHT : 0;
  const estimatedMenuHeight = options.buttons.length * LAYOUT.ITEM_HEIGHT;
  const estimatedTotalHeight = estimatedHeaderHeight + estimatedMenuHeight;

  const spaceBelow = window.innerHeight - triggerPosition.y;
  const spaceAbove = triggerPosition.y;
  const spaceRight = window.innerWidth - triggerPosition.x;
  const spaceLeft = triggerPosition.x;

  const vertical: VerticalOrigin =
    spaceBelow < estimatedTotalHeight + LAYOUT.BOTTOM_PADDING &&
    spaceAbove > spaceBelow
      ? "top"
      : "bottom";

  const horizontal: HorizontalOrigin =
    spaceRight < LAYOUT.MENU_WIDTH + LAYOUT.VIEWPORT_MARGIN &&
    spaceLeft > spaceRight
      ? "right"
      : "left";

  const placement: Placement = `${vertical} ${horizontal === "left" ? "start" : "end"}`;

  return { placement };
}

export function calculateHighlightPosition(
  itemElement: HTMLElement | null,
  menuElement: HTMLElement | null
): { top: number; height: number } | null {
  if (!itemElement || !menuElement) {
    return null;
  }

  const menuRect = menuElement.getBoundingClientRect();
  const itemRect = itemElement.getBoundingClientRect();

  return {
    top: itemRect.top - menuRect.top,
    height: itemRect.height
  };
}
